import { FormikProps } from "formik";
import { Permissions, User } from "../../types/User";
import { IconButton, Rating, Stack } from "@mui/material";
import { Switch } from "../form/Switch";
import { useAuthStore } from "../../store/auth.store";
import React, { useMemo } from "react";
import { DateTime } from "../form/DateTime";
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';

export function UserPermissionsControl({ formik }: { formik: FormikProps<User> }) {
    const { can } = useAuthStore();
    const values = useMemo(() => {
        return (formik.values.privileges || []).reduce((map, p) => {
            map[p.privilege] = true;
            return map;
        }, {} as Record<keyof Permissions, boolean>);
    }, [formik.values])

    const fullAccess = can('full_access')
    const canManageUsers = fullAccess || can('manage_users')

    function changePermission(key: keyof Permissions) {
        const privileges = [...(formik.values.privileges || [])];
        if (!values[key]) {
            privileges.push({ id: '', privilege: key })
        } else {
            for (let i = 0; i < privileges.length; i++) {
                const priv = privileges[i];
                if (priv.privilege === key) {
                    privileges.splice(i, 1);
                    break
                }
            }
        }
        formik.setFieldValue('privileges', privileges, false);
    }

    const userHavePremium = useMemo(() => {
        return !!(formik?.values?.privileges || []).filter(p => p.privilege === 'see_premium')[0]
    }, [formik.values.privileges])

    if (!canManageUsers) {
        return null;
    }

    return <Stack className={"mb-15"}>
        <h3>Privileges</h3>
        {fullAccess && <Switch
            label={"Full Access"}
            checked={values.full_access || false}
            onChange={() => changePermission('full_access')}/>}
        {canManageUsers && <Stack flexDirection={"row"} gap={'15px'}>
            <Stack sx={{flex: '1 0 auto'}} gap={'15px'} flexDirection={"row"} alignItems={"center"}>
                <IconButton onClick={() => changePermission('see_premium')}>
                    {values.see_premium && <StarOutlinedIcon fontSize={"large"} htmlColor={"#faaf00"} />}
                    {!values.see_premium && <StarOutlineOutlinedIcon fontSize={"large"} />}
                </IconButton>
                <span className={"cursor-pointer"} onClick={() => changePermission('see_premium')} >See Premium</span>
            </Stack>
            <DateTime
                label={"Premium Expiration Date"}
                disabled={!userHavePremium}
                name={"premiumExpiration"}
                formik={formik}
            />
        </Stack>}
        {canManageUsers && <Switch
            label={"Manage Users"}
            checked={values.manage_users || false}
            onChange={() => changePermission('manage_users')}/>}
        {canManageUsers && <Switch
            label={"Manage Proposals"}
            checked={values.manage_proposals || false}
            onChange={() => changePermission('manage_proposals')}/>}
        {canManageUsers && <Switch
            label={"Support Agent"}
            checked={values.be_support || false}
            onChange={() => changePermission('be_support')}/>}
    </Stack>
}